import * as ko from 'knockout'
import OnResize from 'element-resize-detector'
import './ko-extenders'

import { EmbedPage } from '~/embed'
window['tixaOrigin'] = window.origin

window.addEventListener('load', () => {
  let pong = false

  window.addEventListener('message', (ev) => {
    if (ev.origin !== document.location.origin) {
      if (ev.data && ev.data.action && ev.data.action === 'pong') {
        if (!pong) {
          pong = true
          window.parent.postMessage({ action: 'getAttrs' }, '*')
        }
      }
      if (ev.data && ev.data.action && ev.data.action === 'setAttrs') {
        const app = document.querySelector('#app')
        OnResize().listenTo(app, (element: HTMLElement) => {
          if (pong) {
            window.parent.postMessage(
              { action: 'setHeight', height: element.clientHeight },
              '*'
            )
          }
        })
        const page = new EmbedPage(ev.data)
        ko.applyBindings(page)
      }
    }
  })

  const pinger = () => {
    window.parent.postMessage({ action: 'ping' }, '*')
    setTimeout(() => {
      if (!pong) {
        pinger()
      }
    }, 200)
  }
  pinger()
})
